export default __webpack_public_path__ + "static/media/003-radar.c4064768.png";